module.exports = __webpack_public_path__ + "img/clashOfWar.3920a4fd.png";